<template>
    <div class="schoolCard-detail">
      <template v-if="data.SystemUpgrading" >
        <SystemUpdating/>
      </template>
      <template>
        <div class="details-center">
            <div class="box1">
                <p>{{data.borrowCount || '-'}}</p>
                <span>当前借阅</span>
            </div>
            <div class="box2">
                <p>{{data.bookPastDue || '-'}}</p>
                <span>过期应还</span>
            </div>
            <div class="box3">
                <p>{{data.bookArrearage || '-'}}</p>
                <span>图书欠费</span>
            </div>
        </div>
        <hr>
        <div class="details-recode">
            <ul v-for="(item,index) in data.shouldRepayList" :key="index">
                <li class="details-recode-time">{{item.shouldRepayBookName}}</li>
                <li class="details-recode-consume">{{item.shouldRepayBookDate}}</li>
            </ul>

        </div>
        <GoMore v-if="data.pcUrl" text="更多借阅记录&gt;&gt;" :jumpUrl="data.pcUrl"/>
      </template>
    </div>

</template>

<script>
    import GoMore from "./GoMore"
    import SystemUpdating from "./SystemUpdating"
    export default {
        name: "Books",
        components: {
            GoMore,
          SystemUpdating
        },
        props: {
            data:  { type: Object, default:()=>{}},
        },
    }
</script>

<style scoped lang="scss">
    .schoolCard-detail {
        height: 253px;
        background: #e8eaf3;
        text-align: center;
        .details-center {
            display: flex;
          box-sizing: border-box;
            justify-content: space-around;
           padding-top: 30px;
            .box1,.box2,.box3 {
                text-align: center;
                p {
                    font-size: 28px;
                    color: #3a3550;
                }
                span {
                    font-size: 12px;
                    color: #3a3550;
                }
            }
        }
        hr {
          border: 1px dashed #995a73;
          width: 90%;
          margin: 19px auto 15px;
        }
        .details-recode {
            padding-left: 20px;
            padding-right: 20px;
            height: 75px;
            overflow: hidden;
            ul {
                display: flex;
                justify-content: space-between;
                line-height: 25px;
                li {
                    font-size: 12px;
                    color: #3a3550;
                    &:first-child {
                        width: 50%;
                        text-overflow: ellipsis;
                        white-space: nowrap;
                        overflow: hidden;
                        text-align: left;
                    }


                }

            }
        }



    }

</style>